<template>
    <div class="modal" tabindex="-1" role="dialog" id="muven-confirmation-exclusion-modal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <span>{{title}}</span>
                    </h5>
                </div>
                <div class="modal-body">
                    <div>
                        <p v-html="message"></p>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" 
                        class="btn btn-outline-danger" 
                        @click="confirm()"
                        :disabled="loading">
                        <fa icon="exclamation-triangle" class="mr-1" v-show="!loading"/>
                        <fa icon="sync-alt" class="mr-1" spin v-show="loading"/>

                        Sim, excluir
                    </button>

                    <button type="button" 
                        class="btn btn-outline-secondary" 
                        @click="close()">Fechar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const ID_MODAL = '#muven-confirmation-exclusion-modal'

import ModalService from '../services/ModalService';
export default {
    name: 'ConfirmationExclusionModalCmp',
    data() {
        return {
            loading: false,
            id: undefined,
            title: '',
            message: '',
        }
    },
    methods: {
        open({id, title, message, additionalData}) {
            this.loading = false;
            this.id = id;
            this.title = title;
            this.message = message;
            this.additionalData = additionalData || null;

            ModalService.show(ID_MODAL)
        },
        confirm() {
            this.loading = true;
            this.$emit('confirm', {id: this.id, additionalData: this.additionalData})
        },
        close() {
            ModalService.hide(ID_MODAL)
        },
    },     
}
</script>

<style lang="scss" scoped>
.modal {
    .modal-header {
        .icon-warning {
            color: var(--danger-solid);
            margin-right: 10px;
        }
    }    

    .modal-body {
        p {
            &:last-of-type {
                margin-bottom: 0;
            }            
        }        
    }
}
</style>